<div>
    <div>Pause duration : <span class="red-1">{{ _pauseDuration }}</span> minutes</div>
    <div>
        Policy will be paused till <strong class="red-1">{{ _pauseEndDateTime | date:'yyyy-MM-dd HH:mm'}}</strong>.
    </div>
</div>